import React, { ComponentPropsWithoutRef } from 'react';
import { Typography } from '@rbx/ui';

import useMarkdownBlockQuoteStyles from './MarkdownBlockQuote.styles';

type BlockQuoteProps = ComponentPropsWithoutRef<'blockquote'>;

export default function MarkdownBlockQuote({ children, ...otherProps }: BlockQuoteProps) {
  const {
    classes: { innerContainer, outerContainer, typographyContainer },
  } = useMarkdownBlockQuoteStyles();

  return (
    <div className={outerContainer}>
      <div className={innerContainer}>
        <Typography
          {...otherProps}
          color='primary'
          variant='body1'
          className={typographyContainer}
          paragraph>
          {children}
        </Typography>
      </div>
    </div>
  );
}
